/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { Fragment } from 'react';

import { ExternalLink, TextBlock } from '../../../components/common';
import { ELinkTarget } from '../../../components/common/ExternalLink/ExternalLink';
import {
    FooterModalStyled,
    FooterModalTextStyled,
    FooterModalTitleStyled,
} from '../../../components/Table/components/footerModal/styled/footerModalStyled';
import PageLocale from '../../internationalization/components/PageLocale';
import { TranslationFileNamesEnum } from '../../internationalization/constants';

export interface IPromisedPaymentErrorModalProps {
    message: string;
    onCloseModal: () => void;
    title?: string;
    linkText?: string;
    linkUrl?: string;
}

const PromisedPaymentErrorModal = (props: IPromisedPaymentErrorModalProps) => {
    return <Fragment>

        <PageLocale lazy
                    fileNames={[
                        TranslationFileNamesEnum.promisedPayment,
                    ]}/>

        <FooterModalStyled>
            <FooterModalTitleStyled className="mb-3">
                {props.title}
            </FooterModalTitleStyled>
            <FooterModalTextStyled>
                <TextBlock>{props.message}</TextBlock>
            </FooterModalTextStyled>
            {
                !!props.linkUrl &&
                <FooterModalTextStyled className="mt-5">
                    <ExternalLink href={props.linkUrl} target={ELinkTarget.BLANK}>{props.linkText}</ExternalLink>
                </FooterModalTextStyled>
            }
        </FooterModalStyled>

    </Fragment>;
};

export default PromisedPaymentErrorModal;
